/* Bloodline product card quick add.
   Mirrors the theme's product-form.js flow (same request, same pub/sub event, same
   cart-drawer refresh) so the Snitch drawer and the Essential Cart Drawer app react
   exactly as they do to the theme's own add-to-cart buttons. */
(function () {
  if (window.BLCart) return;

  function closeAll(except) {
    document.querySelectorAll('.bl-card.is-picking').forEach(function (card) {
      if (card === except) return;
      card.classList.remove('is-picking');
      var t = card.querySelector('[data-bl-qa-open]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  function setMsg(card, text) {
    var msg = card && card.querySelector('.bl-card__msg');
    if (msg) msg.textContent = text || '';
  }

  function variants(card) {
    if (!card._blVariants) {
      var el = card.querySelector('[data-bl-variants]');
      try { card._blVariants = el ? JSON.parse(el.textContent) : []; } catch (e) { card._blVariants = []; }
    }
    return card._blVariants;
  }

  /* Selected values for the "select" rows (e.g. Color); null where the option has one value. */
  function selection(card) {
    var sel = [];
    card.querySelectorAll('.bl-card__sizes-list--select').forEach(function (row) {
      var on = row.querySelector('[aria-pressed="true"]');
      sel[parseInt(row.getAttribute('data-bl-option'), 10)] = on ? on.value : null;
    });
    return sel;
  }

  function matchVariant(card, index, value) {
    var sel = selection(card);
    return variants(card).filter(function (v) {
      if (v.o[index] !== value) return false;
      return sel.every(function (s, i) { return s == null || v.o[i] === s; });
    })[0];
  }

  /* Disable last-row chips that are sold out for the current selection. */
  function sync(card) {
    var row = card.querySelector('.bl-card__sizes-list:not(.bl-card__sizes-list--select)');
    if (!row) return;
    var index = parseInt(row.getAttribute('data-bl-option'), 10);
    row.querySelectorAll('[data-bl-pick]').forEach(function (chip) {
      var v = matchVariant(card, index, chip.value);
      chip.disabled = !(v && v.a);
    });
  }

  function add(btn, variantId) {
    var card = btn.closest('[data-bl-card]');
    var id = variantId || btn.getAttribute('data-bl-add');
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    setMsg(card, '');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'bl-product-card', productVariantId: id, errors: res.description, message: res.message });
          }
          setMsg(card, res.description || res.message);
          return;
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bl-product-card', productVariantId: id, cartData: res });
        }
        if (card) {
          card.classList.add('is-added');
          setTimeout(function () { card.classList.remove('is-added', 'is-picking'); }, 1400);
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(res);
        }
        document.dispatchEvent(new CustomEvent('bl:cart:added', { detail: { variantId: id, item: res } }));
      })
      .catch(function (e) {
        console.error(e);
        setMsg(card, btn.getAttribute('data-bl-error') || '');
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-bl-add]');
    if (addBtn) { e.preventDefault(); add(addBtn); return; }

    var select = e.target.closest('[data-bl-select]');
    if (select) {
      e.preventDefault();
      select.parentNode.querySelectorAll('[data-bl-select]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === select ? 'true' : 'false');
      });
      sync(select.closest('[data-bl-card]'));
      return;
    }

    var pick = e.target.closest('[data-bl-pick]');
    if (pick) {
      e.preventDefault();
      var pc = pick.closest('[data-bl-card]');
      var row = pick.closest('[data-bl-option]');
      var v = matchVariant(pc, parseInt(row.getAttribute('data-bl-option'), 10), pick.value);
      if (v && v.a) add(pick, String(v.id));
      return;
    }

    var open = e.target.closest('[data-bl-qa-open]');
    if (open) {
      e.preventDefault();
      var card = open.closest('[data-bl-card]');
      closeAll(card);
      var on = card.classList.toggle('is-picking');
      open.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) {
        sync(card);
        var first = card.querySelector('.bl-size:not([disabled])');
        if (first) first.focus({ preventScroll: true });
      }
      return;
    }

    if (e.target.closest('[data-bl-qa-close]') || !e.target.closest('.bl-card__sizes')) closeAll();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  window.BLCart = { add: add };
})();
